import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_add_entity_info",
  ref: "addModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header bg-primary",
  id: "kt_modal_add_entity_info_header"
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-light" }, "Add Info"),
  /*#__PURE__*/_createElementVNode("div", {
    id: "kt_modal_add_entity_info_close",
    "data-bs-dismiss": "modal",
    class: "btn btn-icon btn-sm btn-active-icon-primary"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_6 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_entity_info_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_entity_info_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_entity_info_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_7 = { class: "fv-row mb-7" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Types"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Types"
  })
], -1)
const _hoisted_9 = { class: "fv-row mb-7" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Registration Number"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Registration Number"
  })
], -1)
const _hoisted_11 = { class: "fv-row mb-7" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Registration Authority"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Registration Authority"
  })
], -1)
const _hoisted_13 = { class: "fv-row mb-7" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Postcode"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Postcode"
  })
], -1)
const _hoisted_15 = { class: "fv-row mb-7" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Sub-district"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Sub-district"
  })
], -1)
const _hoisted_17 = { class: "fv-row mb-7" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "District"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "District"
  })
], -1)
const _hoisted_19 = { class: "fv-row mb-7" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Division"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Division"
  })
], -1)
const _hoisted_21 = { class: "modal-footer flex-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_modal_add_entity_info_cancel",
  class: "btn btn-light me-3"
}, " Discard ", -1)
const _hoisted_23 = ["data-kt-indicator"]
const _hoisted_24 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_25 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_26 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_form, {
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_el_form_item, { prop: "entity_type_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Entity Type",
                        modelValue: _ctx.formData.entity_type_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.entity_type_id) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityTypes, (types) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: types.id,
                              label: types.name,
                              value: types.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(types.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_el_form_item, { prop: "registration_number" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.registration_number,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.registration_number) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_el_form_item, { prop: "registration_authority" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.registration_authority,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.registration_authority) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_el_form_item, { prop: "postcode" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.postcode,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.postcode) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_el_form_item, { prop: "sub_district" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.sub_district,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.sub_district) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_el_form_item, { prop: "district" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.district,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.district) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_el_form_item, { prop: "division" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.division,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.division) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                      _createTextVNode(" Submit "),
                      _createElementVNode("span", _hoisted_25, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                      _createTextVNode(" Please wait... "),
                      _hoisted_27
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_23)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}